<script setup lang="ts"></script>

<template>
  <tw-ui-message-box type="warning" class="box">
    <p>
      {{ $t("login.alert.error") }}
      <br />
      {{ $t("login.alert.error_second") }}
      <tw-ui-action is="link" variant="text-primary" class="login-links" :to="{ name: 'account-forgot-password' }">
        {{ $t("login.alert.link_reset_Password") }}
      </tw-ui-action>
      <span>.</span>
    </p>
    <br />
    <p>
      {{ $t("login.alert.no_account") }}
      <tw-ui-action is="link" variant="text-primary" class="login-links" :to="{ name: 'registrieren' }">
        {{ $t("login.alert.link_register_now") }}
      </tw-ui-action>
    </p>
  </tw-ui-message-box>
</template>

<style scoped lang="scss">
.box {
  margin-bottom: 1rem;

  p {
    margin: 0;
  }
}

.login-links {
  font-weight: normal;
}
</style>
